/**
 * @generated SignedSource<<6e4a987e3d38e3014dd9669b63a2d80f>>
 * @relayHash 5c7e3adbcb7bcaf4de0f4c1490bc6f3a
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ferrum/514.0.0-2025-06-05T08:08:46.929Z/setLangCookieMutation

import { ConcreteRequest } from 'relay-runtime';
export type SetLangCookieInput = {
  clientMutationId?: string | null;
  cookieDomain?: string | null;
  locale?: string | null;
};
export type setLangCookieMutation$variables = {
  input: SetLangCookieInput;
};
export type setLangCookieMutation$data = {
  readonly setLangCookie: {
    readonly clientMutationId: string | null;
  } | null;
};
export type setLangCookieMutation = {
  response: setLangCookieMutation$data;
  variables: setLangCookieMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SetLangCookiePayload",
    "kind": "LinkedField",
    "name": "setLangCookie",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "setLangCookieMutation",
    "selections": (v1/*: any*/),
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "setLangCookieMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "ferrum/514.0.0-2025-06-05T08:08:46.929Z/setLangCookieMutation",
    "metadata": {},
    "name": "setLangCookieMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "fd787194fded1ecfdb78628ca23499b1";

export default node;
